import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

function BatchSortingTip() {
  const content = (
    <div style={{ maxWidth: 260 }}>
      Controls how documents will be sorted by default when you
      <strong> Batch Documents</strong>.
      <br /><br />
      Choose a column to sort by, and whether the default should be
      ascending or descending.
    </div>
  );

  return (
    <Tooltip title={content} placement="right">
      <InfoCircleOutlined style={{ color: "#1890ff", cursor: "pointer" }} />
    </Tooltip>
  );
}

export default BatchSortingTip;